// extracted by mini-css-extract-plugin
export default {"container":"Monetization__container-m9lBr","checkbox":"Monetization__checkbox-QkHd9"};